import { FormattedMessage } from 'react-intl';
import { getMemberKey, getMemberName } from '../AffordaHousehold/utils';
import { BUTTON_GROUP_SX, PAY_FREQUENCY } from './constants';
import {
  FIELD_TEXT_REQUIRED,
  GridProps,
  FIELD_YES_NO,
  FIELD_COUNTER_REQUIRED,
  FIELD_AMOUNT,
  FIELD_MEMBER_SELECTED,
  FIELD_MEMBERS,
} from './constants.fields';
import { validateNoSpecialChars } from 'utils/validateNoSpecialChars';

export const CHILD_SUPPORT_MIN_AGE = 10;

export const MESSAGE_IDS = {
  title: 'afforda.wagesAndIncome.details.childSupport.title',
  description: 'afforda.wagesAndIncome.details.childSupport.subtitle',
  addButton: 'afforda.wagesAndIncome.details.childSupport.add',
  addCaption: 'afforda.wagesAndIncome.details.childSupport.addMembers',
};

export const CHILD_SUPPORT_FIELD_NAMES = {
  annualAmountOrdered: 'annualAmountOrdered',
  annualAmountReceived: 'annualAmountReceived',
  anticipateChildSupport: 'anticipateChildSupport',
  anticipateChildSupportCounty: 'anticipateChildSupportCounty',
  anticipatedState: 'anticipatedState',
  county: 'county',
  explainEfforts: 'explainEfforts',
  forWhomChildName: 'forWhomChildName',
  courtOrderedChildSupport: 'courtOrderedChildSupport',
  memberId: 'memberId',
  monthlyAmountOrdered: 'monthlyAmountOrdered',
  monthlyAmountReceived: 'monthlyAmountReceived',
  numCourtOrdered: 'numCourtOrdered',
  payFrequencyOrdered: 'payFrequencyOrdered',
  payFrequencyReceived: 'payFrequencyReceived',
  reasonableEfforts: 'reasonableEfforts',
  receivingAny: 'receivingAny',
  receivingOrdered: 'receivingOrdered',
  state: 'state',
  weeklyAmountOrdered: 'weeklyAmountOrdered',
  weeklyAmountReceived: 'weeklyAmountReceived',
  whomExpected: 'whomExpected',
  whomExpectedMinors: 'whomExpectedMinors',
  whomReceive: 'whomReceive',
  whomReceiveMinors: 'whomReceiveMinors',
  isOpen: 'isOpen',
  totalIncome: 'totalIncome',
};

export const NEW_CHILD_SUPPORT = {
  [CHILD_SUPPORT_FIELD_NAMES.annualAmountOrdered]: '',
  [CHILD_SUPPORT_FIELD_NAMES.annualAmountReceived]: '',
  [CHILD_SUPPORT_FIELD_NAMES.anticipateChildSupport]: '',
  [CHILD_SUPPORT_FIELD_NAMES.anticipateChildSupportCounty]: '',
  [CHILD_SUPPORT_FIELD_NAMES.anticipatedState]: '',
  [CHILD_SUPPORT_FIELD_NAMES.county]: '',
  [CHILD_SUPPORT_FIELD_NAMES.explainEfforts]: '',
  [CHILD_SUPPORT_FIELD_NAMES.forWhomChildName]: '',
  [CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport]: '',
  [CHILD_SUPPORT_FIELD_NAMES.memberId]: '',
  [CHILD_SUPPORT_FIELD_NAMES.monthlyAmountOrdered]: '',
  [CHILD_SUPPORT_FIELD_NAMES.monthlyAmountReceived]: '',
  [CHILD_SUPPORT_FIELD_NAMES.numCourtOrdered]: '',
  [CHILD_SUPPORT_FIELD_NAMES.payFrequencyOrdered]: '',
  [CHILD_SUPPORT_FIELD_NAMES.payFrequencyReceived]: '',
  [CHILD_SUPPORT_FIELD_NAMES.reasonableEfforts]: '',
  [CHILD_SUPPORT_FIELD_NAMES.receivingAny]: '',
  [CHILD_SUPPORT_FIELD_NAMES.receivingOrdered]: '',
  [CHILD_SUPPORT_FIELD_NAMES.state]: '',
  [CHILD_SUPPORT_FIELD_NAMES.weeklyAmountOrdered]: '',
  [CHILD_SUPPORT_FIELD_NAMES.weeklyAmountReceived]: '',
  [CHILD_SUPPORT_FIELD_NAMES.whomExpected]: [],
  [CHILD_SUPPORT_FIELD_NAMES.whomExpectedMinors]: '',
  [CHILD_SUPPORT_FIELD_NAMES.whomReceive]: [],
  [CHILD_SUPPORT_FIELD_NAMES.whomReceiveMinors]: '',
  [CHILD_SUPPORT_FIELD_NAMES.isOpen]: true,
  [CHILD_SUPPORT_FIELD_NAMES.totalIncome]: 0,
};

export const getDefaultValues = (item) => {
  return {
    ...item,
    id: item.id,
    [CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport]:
      item.courtOrderedChildSupport ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.anticipateChildSupport]:
      item.anticipateChildSupport ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.whomReceive]: item.whomReceive ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.whomReceiveMinors]: item.whomReceiveMinors ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.whomExpected]: item.whomExpected ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.whomExpectedMinors]:
      item.whomExpectedMinors ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.forWhomChildName]: item.forWhomChildName ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.anticipatedState]: item.anticipatedState ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.anticipateChildSupportCounty]:
      item.anticipateChildSupportCounty ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.numCourtOrdered]: item.numCourtOrdered ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.receivingOrdered]: item.receivingOrdered ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.receivingAny]: item.receivingAny ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.payFrequencyOrdered]:
      item.payFrequencyOrdered ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.payFrequencyReceived]:
      item.payFrequencyReceived ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.reasonableEfforts]: item.reasonableEfforts ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.explainEfforts]: item.explainEfforts ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.weeklyAmountOrdered]:
      item.weeklyAmountOrdered ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.monthlyAmountOrdered]:
      item.monthlyAmountOrdered ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.annualAmountOrdered]:
      item.annualAmountOrdered ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.weeklyAmountReceived]:
      item.weeklyAmountReceived ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.monthlyAmountReceived]:
      item.monthlyAmountReceived ?? '',
    [CHILD_SUPPORT_FIELD_NAMES.annualAmountReceived]:
      item.annualAmountReceived ?? '',
  };
};

export const PAY_FREQUENCY_OPTIONS = {
  WEEKLY: {
    value: PAY_FREQUENCY.weekly,
    text: 'afforda.wagesAndIncome.details.job.weekly',
  },
  MONTHLY: {
    value: PAY_FREQUENCY.monthly,
    text: 'afforda.wagesAndIncome.details.job.monthly',
  },
  ANNUALLY: {
    value: PAY_FREQUENCY.annually,
    text: 'afforda.wagesAndIncome.details.job.annually',
  },
};

export const FIELD_AGREEMENT = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport,
  ],
  hidden: ({ getValues }) =>
    !getValues(CHILD_SUPPORT_FIELD_NAMES.memberId)?.length ||
    getValues(CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport) !== 'yes',
};

export const FIELD_NO_AGREEMENT = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.anticipateChildSupport,
    CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport,
  ],
  hidden: ({ getValues }) =>
    !getValues(CHILD_SUPPORT_FIELD_NAMES.memberId)?.length ||
    getValues(CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport) !== 'no',
};

export const FIELD_ANTICIPATED = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.anticipateChildSupport,
  ],
  hidden: ({ getValues }) =>
    !getValues(CHILD_SUPPORT_FIELD_NAMES.memberId)?.length ||
    getValues(CHILD_SUPPORT_FIELD_NAMES.anticipateChildSupport) !== 'yes',
};

export const FIELD_NO_ANTICIPATED = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.anticipateChildSupport,
  ],
  hidden: ({ getValues }) =>
    !getValues(CHILD_SUPPORT_FIELD_NAMES.memberId)?.length ||
    getValues(CHILD_SUPPORT_FIELD_NAMES.anticipateChildSupport) === 'no',
};

export const FIELD_RECEIVING = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.anticipateChildSupport,
    CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport,
  ],
  hidden: ({ getValues }) =>
    !getValues(CHILD_SUPPORT_FIELD_NAMES.memberId)?.length ||
    (getValues(CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport) === 'no' &&
      getValues(CHILD_SUPPORT_FIELD_NAMES.anticipateChildSupport) === 'yes'),
};

export const FIELD_AGREEMENT_PAY_FREQUENCY = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.payFrequencyOrdered,
  ],
  hidden: ({ getValues }) => {
    return (
      !getValues(CHILD_SUPPORT_FIELD_NAMES.memberId)?.length ||
      !getValues(CHILD_SUPPORT_FIELD_NAMES.payFrequencyOrdered)?.length
    );
  },
};

export const FIELD_AGREEMENT_PAY_FREQ_ORDERED = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.receivingOrdered,
  ],
  hidden: ({ getValues }) =>
    !getValues(CHILD_SUPPORT_FIELD_NAMES.memberId)?.length ||
    getValues(CHILD_SUPPORT_FIELD_NAMES.receivingOrdered) !== 'no',
};

export const FIELD_AGREEMENT_RECEIVE_ANY = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.receivingAny,
  ],
  hidden: ({ getValues }) =>
    !getValues(CHILD_SUPPORT_FIELD_NAMES.memberId)?.length ||
    getValues(CHILD_SUPPORT_FIELD_NAMES.receivingAny) !== 'yes',
};

export const FIELD_AGREEMENT_WEEKLY = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport,
    CHILD_SUPPORT_FIELD_NAMES.payFrequencyOrdered,
  ],
  hidden: ({ getValues }) =>
    getValues(CHILD_SUPPORT_FIELD_NAMES.payFrequencyOrdered) !==
    PAY_FREQUENCY.weekly,
};

export const FIELD_AGREEMENT_MONTHLY = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport,
    CHILD_SUPPORT_FIELD_NAMES.payFrequencyOrdered,
  ],
  hidden: ({ getValues }) =>
    getValues(CHILD_SUPPORT_FIELD_NAMES.payFrequencyOrdered) !==
    PAY_FREQUENCY.monthly,
};

export const FIELD_AGREEMENT_ANNUALLY = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport,
    CHILD_SUPPORT_FIELD_NAMES.payFrequencyOrdered,
  ],
  hidden: ({ getValues }) =>
    getValues(CHILD_SUPPORT_FIELD_NAMES.payFrequencyOrdered) !==
    PAY_FREQUENCY.annually,
};

export const FIELD_PAYMENT_FREQ_RECEIVED = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport,
    CHILD_SUPPORT_FIELD_NAMES.receivingAny,
  ],
  hidden: ({ getValues }) =>
    !getValues(CHILD_SUPPORT_FIELD_NAMES.memberId)?.length ||
    getValues(CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport) !== 'yes',
};

export const FIELD_RECEIVE_ANY_WEEKLY = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.payFrequencyReceived,
  ],
  hidden: ({ getValues }) =>
    getValues(CHILD_SUPPORT_FIELD_NAMES.payFrequencyReceived) !==
    PAY_FREQUENCY.weekly,
};

export const FIELD_RECEIVE_ANY_MONTHLY = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.payFrequencyReceived,
  ],
  hidden: ({ getValues }) =>
    getValues(CHILD_SUPPORT_FIELD_NAMES.payFrequencyReceived) !==
    PAY_FREQUENCY.monthly,
};

export const FIELD_RECEIVE_ANY_ANNUALLY = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.payFrequencyReceived,
  ],
  hidden: ({ getValues }) =>
    getValues(CHILD_SUPPORT_FIELD_NAMES.payFrequencyReceived) !==
    PAY_FREQUENCY.annually,
};

export const FIELD_RECEIVE_ANY_PAY_FREQUENCY = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.payFrequencyReceived,
  ],
  hidden: ({ getValues }) =>
    !getValues(CHILD_SUPPORT_FIELD_NAMES.memberId)?.length ||
    !getValues(CHILD_SUPPORT_FIELD_NAMES.payFrequencyReceived)?.length,
};

export const FIELD_NO_RECEIVE_ANY = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.receivingOrdered,
    CHILD_SUPPORT_FIELD_NAMES.receivingAny,
  ],
  hidden: ({ getValues }) =>
    !getValues(CHILD_SUPPORT_FIELD_NAMES.memberId)?.length ||
    getValues(CHILD_SUPPORT_FIELD_NAMES.receivingOrdered) !== 'no',
};

export const FIELD_REASONABLE_YES = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.reasonableEfforts,
  ],
  hidden: ({ getValues }) =>
    !getValues(CHILD_SUPPORT_FIELD_NAMES.memberId)?.length ||
    getValues(CHILD_SUPPORT_FIELD_NAMES.reasonableEfforts) !== 'yes',
};

export const FIELD_REASONABLE_NO = {
  watchFields: [
    CHILD_SUPPORT_FIELD_NAMES.memberId,
    CHILD_SUPPORT_FIELD_NAMES.reasonableEfforts,
  ],
  hidden: ({ getValues }) =>
    !getValues(CHILD_SUPPORT_FIELD_NAMES.memberId)?.length ||
    getValues(CHILD_SUPPORT_FIELD_NAMES.reasonableEfforts) !== 'no',
};

export const FIELD_GROUP_BUTTONS = {
  variant: 'buttonGroup',
  direction: 'column',
  rules: {
    required: true,
  },
  GridProps: {
    xs: 12,
  },
};

const BASE_PAY_FREQUENCY_FIELD = {
  ...FIELD_GROUP_BUTTONS,
  rules: {
    required: true,
  },
  options: Object.values(PAY_FREQUENCY_OPTIONS)?.map((option) => ({
    value: option.value,
    label: <FormattedMessage id={option.text} />,
  })),
  GridProps: {
    xs: 12,
  },
  direction: 'row',
};

export const FIELDS = ({
  currentMemberIds,
  disabledMembers,
  intl,
  memberId,
  members,
  minors,
  states,
}) => {
  const hasMinors = minors?.length > 0;
  // Determine if the current member is an adult
  const isAdult =
    hasMinors && memberId
      ? !minors.map((minor) => getMemberKey(minor)).includes(memberId)
      : false;
  // remove the last item in currentMemberIds if the length > 0 and assign it into another const, if it length is 0 then []
  const memberIds = currentMemberIds.length
    ? currentMemberIds.slice(0, currentMemberIds.length - 1)
    : [];

  const minorOptions = [
    ...(minors?.map((minor) => {
      const memberKey = getMemberKey(minor);
      const isMinorDisabled = !isAdult
        ? memberIds.includes(memberKey) || currentMemberIds.includes(memberKey)
        : false;
      return {
        value: memberKey,
        label: getMemberName(minor),
        disabled: isMinorDisabled,
      };
    }) || []),
    {
      value: 'other',
      label: intl.formatMessage({
        id: 'afforda.wagesAndIncome.details.childSupport.otherMinorLabel',
      }),
    },
  ];

  return [
    ...FIELD_MEMBERS({ members, disabledMembers }),
    {
      ...FIELD_YES_NO,
      ...FIELD_MEMBER_SELECTED,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.courtOrderedChildSupport" />
      ),
      name: CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport,
    },
    {
      ...FIELD_NO_AGREEMENT,
      ...FIELD_YES_NO,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.anticipateChildSupport" />
      ),
      name: CHILD_SUPPORT_FIELD_NAMES.anticipateChildSupport,
    },
    // Whom Receive
    {
      ...FIELD_AGREEMENT,
      name: CHILD_SUPPORT_FIELD_NAMES.whomReceive,
      watchFields: [
        CHILD_SUPPORT_FIELD_NAMES.memberId,
        CHILD_SUPPORT_FIELD_NAMES.anticipateChildSupport,
        CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport,
      ],
      hidden: ({ getValues }) =>
        !hasMinors ||
        !getValues(CHILD_SUPPORT_FIELD_NAMES.memberId)?.length ||
        getValues(CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport) !== 'yes',
      variant: 'buttonGroup',
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.whomReceive" />
      ),
      rules: {
        required: true,
        validate: validateNoSpecialChars,
      },
      direction: 'row',
      sx: BUTTON_GROUP_SX,
      GridProps: {
        xs: 12,
      },
      options: minorOptions,
      multiselect: true,
      helperText: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.selectAll" />
      ),
    },
    {
      ...FIELD_TEXT_REQUIRED,
      watchFields: [
        CHILD_SUPPORT_FIELD_NAMES.memberId,
        CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport,
        CHILD_SUPPORT_FIELD_NAMES.whomReceive,
      ],
      hidden: ({ getValues }) => {
        if (hasMinors) {
          return (
            !getValues(CHILD_SUPPORT_FIELD_NAMES.memberId)?.length ||
            !getValues(CHILD_SUPPORT_FIELD_NAMES.whomReceive)?.includes('other')
          );
        }

        return (
          getValues(CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport) !==
          'yes'
        );
      },
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.whomReceiveMinors" />
      ),
      rules: {
        required: hasMinors
          ? ({ getValues }) =>
              getValues(CHILD_SUPPORT_FIELD_NAMES.whomReceive)?.includes(
                'other',
              )
          : false,
        validate: validateNoSpecialChars,
      },
      placeholder: intl.formatMessage({
        id: 'afforda.wagesAndIncome.details.childSupport.nameMinors',
      }),
      name: CHILD_SUPPORT_FIELD_NAMES.whomReceiveMinors,
    },
    // Whom Expected
    {
      ...FIELD_ANTICIPATED,
      name: CHILD_SUPPORT_FIELD_NAMES.whomExpected,
      variant: 'buttonGroup',
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.whomExpected" />
      ),
      rules: {
        required: true,
        validate: validateNoSpecialChars,
      },
      direction: 'row',
      sx: BUTTON_GROUP_SX,
      GridProps: {
        xs: 12,
      },
      options: minorOptions,
      hidden: ({ getValues }) =>
        !hasMinors ||
        !getValues(CHILD_SUPPORT_FIELD_NAMES.memberId)?.length ||
        getValues(CHILD_SUPPORT_FIELD_NAMES.anticipateChildSupport) !== 'yes',
      multiple: true,
      multiselect: true,
      helperText: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.selectAll" />
      ),
    },
    {
      ...FIELD_TEXT_REQUIRED,
      watchFields: [
        CHILD_SUPPORT_FIELD_NAMES.memberId,
        CHILD_SUPPORT_FIELD_NAMES.whomExpected,
      ],
      hidden: ({ getValues }) =>
        !minors?.length ||
        !getValues(CHILD_SUPPORT_FIELD_NAMES.memberId)?.length ||
        !getValues(CHILD_SUPPORT_FIELD_NAMES.whomExpected)?.includes('other'),
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.whomExpected" />
      ),
      rules: {
        required: ({ getValues }) =>
          getValues(CHILD_SUPPORT_FIELD_NAMES.whomExpected)?.includes('other'),
        validate: validateNoSpecialChars,
      },
      placeholder: intl.formatMessage({
        id: 'afforda.wagesAndIncome.details.childSupport.nameMinors',
      }),
      name: CHILD_SUPPORT_FIELD_NAMES.whomExpectedMinors,
    },
    {
      ...FIELD_COUNTER_REQUIRED,
      ...FIELD_AGREEMENT,
      rules: {
        required: false,
        min: 1,
        max: 10,
      },
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.numCourtOrdered" />
      ),
      name: CHILD_SUPPORT_FIELD_NAMES.numCourtOrdered,
      helperText: (
        <FormattedMessage id="afforda.wagesAndIncome.details.job.optional" />
      ),
    },
    // Anticipated
    {
      ...FIELD_ANTICIPATED,
      variant: 'singleSelect',
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.state" />
      ),
      name: CHILD_SUPPORT_FIELD_NAMES.anticipatedState,
      rules: {
        required: true,
      },
      GridProps,
      options: states?.map((state) => ({
        text: state.name,
        value: state.id,
      })),
    },
    {
      ...FIELD_ANTICIPATED,
      ...FIELD_TEXT_REQUIRED,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.county" />
      ),
      name: CHILD_SUPPORT_FIELD_NAMES.anticipateChildSupportCounty,
      rules: {
        required: true,
      },
      GridProps,
    },
    // PayFreq Ordered
    {
      ...BASE_PAY_FREQUENCY_FIELD,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.payFrequencyOrdered" />
      ),
      name: CHILD_SUPPORT_FIELD_NAMES.payFrequencyOrdered,
      watchFields: [
        CHILD_SUPPORT_FIELD_NAMES.memberId,
        CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport,
        CHILD_SUPPORT_FIELD_NAMES.whomReceive,
      ],
      hidden: ({ getValues }) => {
        if (hasMinors) {
          return (
            !getValues(CHILD_SUPPORT_FIELD_NAMES.memberId)?.length ||
            getValues(CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport) !==
              'yes' ||
            (!getValues(CHILD_SUPPORT_FIELD_NAMES.whomReceive)?.length &&
              !getValues(CHILD_SUPPORT_FIELD_NAMES.whomReceiveMinors)?.length)
          );
        }

        return (
          getValues(CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport) !==
          'yes'
        );
      },
    },
    {
      ...FIELD_AMOUNT,
      ...FIELD_AGREEMENT_WEEKLY,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.weeklyAmountOrdered" />
      ),
      name: CHILD_SUPPORT_FIELD_NAMES.weeklyAmountOrdered,
    },
    {
      ...FIELD_AMOUNT,
      ...FIELD_AGREEMENT_MONTHLY,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.monthlyAmountOrdered" />
      ),
      name: CHILD_SUPPORT_FIELD_NAMES.monthlyAmountOrdered,
    },
    {
      ...FIELD_AMOUNT,
      ...FIELD_AGREEMENT_ANNUALLY,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.annualAmountOrdered" />
      ),
      name: CHILD_SUPPORT_FIELD_NAMES.annualAmountOrdered,
    },
    // Received
    {
      ...FIELD_YES_NO,
      ...FIELD_AGREEMENT_PAY_FREQUENCY,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.receivingOrdered" />
      ),
      name: CHILD_SUPPORT_FIELD_NAMES.receivingOrdered,
    },
    {
      ...FIELD_YES_NO,
      ...FIELD_AGREEMENT_PAY_FREQ_ORDERED,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.receivingAny" />
      ),
      name: CHILD_SUPPORT_FIELD_NAMES.receivingAny,
    },
    // PayFreq Received and No and any yes.
    {
      ...BASE_PAY_FREQUENCY_FIELD,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.payFrequencyReceived" />
      ),
      name: CHILD_SUPPORT_FIELD_NAMES.payFrequencyReceived,
      watchFields: [
        CHILD_SUPPORT_FIELD_NAMES.memberId,
        CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport,
        CHILD_SUPPORT_FIELD_NAMES.anticipateChildSupport,
        CHILD_SUPPORT_FIELD_NAMES.whomReceive,
        CHILD_SUPPORT_FIELD_NAMES.receivingAny,
      ],
      hidden: ({ getValues }) => {
        return (
          getValues(CHILD_SUPPORT_FIELD_NAMES.courtOrderedChildSupport) !==
            'yes' || getValues(CHILD_SUPPORT_FIELD_NAMES.receivingAny) !== 'yes'
        );
      },
    },
    {
      ...FIELD_AMOUNT,
      ...FIELD_RECEIVE_ANY_WEEKLY,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.weeklyAmountReceived" />
      ),
      name: CHILD_SUPPORT_FIELD_NAMES.weeklyAmountReceived,
    },
    {
      ...FIELD_AMOUNT,
      ...FIELD_RECEIVE_ANY_MONTHLY,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.monthlyAmountReceived" />
      ),
      name: CHILD_SUPPORT_FIELD_NAMES.monthlyAmountReceived,
    },
    {
      ...FIELD_AMOUNT,
      ...FIELD_RECEIVE_ANY_ANNUALLY,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.annualAmountReceived" />
      ),
      name: CHILD_SUPPORT_FIELD_NAMES.annualAmountReceived,
    },
    // Efforts
    {
      ...FIELD_YES_NO,
      ...FIELD_NO_RECEIVE_ANY,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.reasonableEfforts" />
      ),
      name: CHILD_SUPPORT_FIELD_NAMES.reasonableEfforts,
    },
    {
      ...FIELD_REASONABLE_YES,
      variant: 'singleSelect',
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.state" />
      ),
      name: CHILD_SUPPORT_FIELD_NAMES.state,
      rules: {
        required: true,
      },
      GridProps,
      options: states?.map((state) => ({
        text: state.name,
        value: state.id,
      })),
    },
    {
      ...FIELD_REASONABLE_YES,
      ...FIELD_TEXT_REQUIRED,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.county" />
      ),
      name: CHILD_SUPPORT_FIELD_NAMES.county,
      rules: {
        required: true,
      },
      GridProps,
    },
    {
      ...FIELD_REASONABLE_NO,
      ...FIELD_TEXT_REQUIRED,
      multiline: true,
      rows: 4,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.childSupport.explainEfforts" />
      ),
      placeholder: intl.formatMessage({
        id: 'afforda.wagesAndIncome.details.childSupport.explain',
      }),
      name: CHILD_SUPPORT_FIELD_NAMES.explainEfforts,
    },
  ];
};
